import { TextField } from "@mui/material";
import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { TextM } from "../../common/text";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;

  padding-top: 30px;
  margin-bottom: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    padding-top: 5px;
    margin-bottom: 40px;
  }
`;

export const Wrapper = styled.div`
  width: 60%;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;
  gap: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 40px;
    margin-bottom: 70px;
  }
`;

export const PasswordInput = styled(TextField)`
  width: 100%;
  height: 25px;
  .MuiInputBase-input {
    font-size: 16px;
  }
  label.Mui-focused {
    color: #f44b59;
  }
  .MuiInput-underline:after {
    border-bottom-color: #f44b59;
  }
  .MuiFormHelperText-root {
    color: #f44b59;
  }
  @media ${({ theme }) => theme.device.tablet} {
    height: 45px;
    .MuiInputBase-input {
      font-size: 24px;
    }
    .MuiFormHelperText-root {
      font-size: 18px;
    }
  }
`;

export const LabelText = styled.span`
  font-size: 20px;
  font-family: "Bold";
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 28px;
  }
`;

export const NextButton = styled.div`
  width: 60%;
  height: 50px;
  background-color: ${({ isValidPassword }) =>
    isValidPassword ? "#f44b59" : "#eaeaea"};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    height: 60px;
  }
`;

export const NextButtonText = styled(TextM)`
  color: ${({ isValidPassword }) => (isValidPassword ? "#FFF" : "#9F9F9F")};
`;
